import {injectable} from "tsyringe";
import {CreateIssueTypeCommand} from "../commands/create-issue-type.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueType} from "../domain/entities/issue-type.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: CreateIssueTypeCommand,
    target: `dto`
})
export class CreateIssueTypeCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueType> {

    protected toDTO(issueType: IssueType): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(issueType)
    }

}